var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeFileMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-medical",
    "data-name": "Icon awesome-file-medical",
    d: "M26.508,7.383,19.624.492A1.686,1.686,0,0,0,18.429,0H18V9h9V8.571A1.682,1.682,0,0,0,26.508,7.383ZM15.75,9.563V0H1.688A1.683,1.683,0,0,0,0,1.688V34.313A1.683,1.683,0,0,0,1.688,36H25.313A1.683,1.683,0,0,0,27,34.313V11.25H17.438A1.692,1.692,0,0,1,15.75,9.563Zm4.5,11.25v3.375a.564.564,0,0,1-.562.563H15.75v3.938a.564.564,0,0,1-.562.563H11.813a.564.564,0,0,1-.562-.562V24.75H7.313a.564.564,0,0,1-.562-.562V20.813a.564.564,0,0,1,.563-.562H11.25V16.313a.564.564,0,0,1,.563-.562h3.375a.564.564,0,0,1,.563.563V20.25h3.938A.564.564,0,0,1,20.25,20.813Z",
    fill: "#0c8de0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFileMedical);
export default __webpack_public_path__ + "static/media/Icon awesome-file-medical.bccdc3ed9be25d1df498f4970618a5b5.svg";
export { ForwardRef as ReactComponent };